import { Link } from "react-router-dom";

const Gift = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Gift Coupon{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section border-bottom pt-5 gift-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-12 col-xs-12">
              <div className="gift-card">
                <div className="gift-card-box text-center">
                  <div className="site-logo text-center">
                    <Link to="/">fashion Hub</Link>
                  </div>
                  <p className="gift-tagline">
                    A Special gift just for you <br /> <span> Gift Cards </span>
                  </p>
                  <div className="coupon-price">$5,000.00</div>
                  <div className="row">
                    <div className="col-lg-6 col-sm-6 col-xs-6 align-self-center">
                      <div className="bar-code">
                        <img src="images/bar-code.jpg" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-6 col-xs-pl-0 align-self-center">
                      <div className="bar-code-info">
                        <p>
                          {" "}
                          Value:$5,000.00 <br />
                          Release Date : 15 Aug 2021 <br />
                          Valid Date : 25 Dec 2021 <br />
                        </p>
                        <p>
                          Call the 24/7 <br /> Helpline: 877-908-3360 <br />
                          htpps://www.fashion-hub.com
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <h6>Shop Now </h6>
                    <p className="mb-1">Clothing | Kids items | Fashion </p>
                    <p>htpps://www.fashion-hub.com</p>
                  </div>
                </div>
              </div>
            </div>
            {/* col */}
            <div className="col-lg-6 col-sm-12 col-xs-12">
              <div className="gift-card-form bg-light">
                <h3 className="mb-2">fashion Hub Gift Card</h3>
                <p className="fs-30">$. 2,000.00</p>
                <p>
                  Tax included. <a href="#">Shipping</a> calculated at checkout.
                </p>
                <div className="field">
                  <label>Gift by</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                  />
                </div>
                <div className="field">
                  <div className="quantity-box">
                    <p>Quantity</p>
                    <div className="number-input md-number-input mb-0">
                      <button
                        onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                        className="minus icon-btn"
                      >
                        <i className="lni lni-minus" />
                      </button>
                      <input
                        className="quantity form-control"
                        min={0}
                        name="quantity"
                        defaultValue={1}
                        type="number"
                      />
                      <button
                        onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                        className="plus icon-btn"
                      >
                        <i className="lni lni-plus" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label>Denominations</label>
                  <select className="form-control">
                    <option>$500.00</option>
                    <option>$1,000.00</option>
                    <option selected="selected">$1,500.00</option>
                    <option>$2,000.00</option>
                    <option>$2,500.00</option>
                    <option>$3,500.00</option>
                    <option>$4,500.00</option>
                    <option>$5,000.00</option>
                    <option>$10,000.00</option>
                    <option>$15,000.00</option>
                  </select>
                </div>
                <div className="field">
                  <div className="btn-section">
                    <button>Add to Cart</button>
                    <button>Procceed to checkout</button>
                  </div>
                </div>
                <div className="field mb-0">
                  <p>
                    <small>
                      Our Group Is Glad To Address Any Inquiries. For Help, Look
                      at Our <a href="#"> FAQ </a> Or
                      <a href="emailtto:contact@gmail.com">e-mail</a> . We're
                      Consistently Here To Help.{" "}
                    </small>
                  </p>
                </div>
              </div>
            </div>
            {/* col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gift;
